import React, { useEffect, useRef } from "react";
import HtmlWithPdfLinks from "../../components/HtmlWithPdfLinks"; 

export default function HtmlWithGap({ bodyHtml, fetchPdf }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Get all <p> elements directly under the container
    const paragraphs = container.querySelectorAll("p");
    paragraphs.forEach((p) => {
      p.style.marginBottom = "9px"; // add gap
    });
  }, [bodyHtml]);

  return (
    <div ref={containerRef}>
      <HtmlWithPdfLinks bodyHtml={bodyHtml} fetchPdf={fetchPdf} />
    </div>
  );
}
